import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c94b2510"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "m-80px" }, null, -1))
const _hoisted_2 = { class: "return-footer p-px-3 p-pt-2" }
const _hoisted_3 = { class: "p-d-flex p-jc-between" }
const _hoisted_4 = { class: "w-100 p-pt-2 p-pr-1" }
const _hoisted_5 = { class: "w-100 p-pt-2 p-pl-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReturnProductDetailDisplay = _resolveComponent("ReturnProductDetailDisplay")!
  const _component_ReturnFinanceForm = _resolveComponent("ReturnFinanceForm")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _createVNode(_component_ReturnProductDetailDisplay, {
        isDisplayProduct: _ctx.isDisplayProduct,
        isDisplayShipProductForm: true,
        isDisableShipping: _ctx.isDisplay
      }, null, 8, ["isDisplayProduct", "isDisableShipping"]),
      _createVNode(_component_ReturnFinanceForm, { isDisplay: _ctx.isDisplay }, null, 8, ["isDisplay"])
    ]),
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_Button, {
            label: "ยกเลิก",
            class: "p-button-outlined p-button-danger w-100"
          })
        ]),
        _createElementVNode("div", _hoisted_5, [
          (!_ctx.isDisplay)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 0,
                label: "ตรวจสอบข้อมูล",
                class: "w-100 p-button-danger",
                onClick: _ctx.setReturnState
              }, null, 8, ["onClick"]))
            : _createCommentVNode("", true),
          (_ctx.isDisplay)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 1,
                label: "ส่งข้อมูล",
                class: "w-100 p-button-danger",
                onClick: _ctx.onSetReturnState
              }, null, 8, ["onClick"]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}